module.exports = __webpack_public_path__ + "static/logoV1-609aa3df4b97c967583b50451f2a5af5.png";